import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

function KeyError() {
  return (
    <Fragment>
      <Helmet>
        <title>There Was an Error with Your Key</title>
      </Helmet>
      <div className="not-found-page">
        <h1 className="not-found-page__heading not-found-page__heading--blue">
          There Was an Error with Your&nbsp;Key
        </h1>
        <div className="not-found-page__subheading">
          You may have already registered with this email address, or your key may have expired. Please speak with your account administrator if you need a new registration key.
        </div>
        <div className="not-found-page__button-wrapper">
          <Link to="/" className="button">
            Back to Home
          </Link>
        </div>
      </div>
    </Fragment>
  );
}

export default KeyError;



// WEBPACK FOOTER //
// ./src/components/common/KeyError.js